import React from "react";
import type { ProductLightDto } from "../../../../../../domain/types/shop";
import {
  PREVIEW_COLORS,
  SECTION_COLUMN_CLASS,
  SECTION_GRID_ROWS,
} from "../../constants";

interface PreviewAllProductsProps {
  products: ProductLightDto[] | null;
  title?: string | null;
  subtitle?: string | null;
  /** 쇼핑몰 `.all-products .products-track` 의 grid-template-columns 에 대응 */
  columnCount?: number;
}

export const PreviewAllProducts = ({
  products,
  title,
  subtitle,
  columnCount = 4,
}: PreviewAllProductsProps) => {
  const columnClass =
    SECTION_COLUMN_CLASS[columnCount] ?? SECTION_COLUMN_CLASS[4];
  // 쇼핑몰은 열 수 × 2행을 한 페이지로 넘긴다. 미리보기도 한 페이지만 보여준다.
  const itemsPerPage = columnCount * SECTION_GRID_ROWS;

  return (
    <div className="text-start flex flex-col flex-start py-[40px] px-[32px]">
      <h2
        className="mb-[1.5rem] text-[1.125rem] font-semibold"
        style={{ color: PREVIEW_COLORS.sectionTitle }}
      >
        {title || "전체 상품"}
      </h2>
      {subtitle ? (
        <div
          className="mt-[-1rem] mb-[1.5rem]"
          style={{ color: PREVIEW_COLORS.sectionSubtitle }}
        >
          {subtitle}
        </div>
      ) : null}
      <div className={`grid ${columnClass} gap-[16px] / items-center`}>
        {products?.slice(0, itemsPerPage).map((product) => {
          return (
            <>
              <div className="w-full">
                <div
                  className="drop-shadow-lg aspect-[1/1] rounded-[0.625rem] mb-[0.75rem]"
                  style={{
                    backgroundColor: PREVIEW_COLORS.thumbnailPlaceholder,
                  }}
                >
                  <img
                    src={product.thumbnail ?? ""}
                    alt="썸네일 이미지."
                    className="object-cover h-full rounded-[0.625rem] w-full"
                  />
                </div>
                <div className="">
                  <h4
                    className="font-medium"
                    style={{ color: PREVIEW_COLORS.allProducts.productName }}
                  >
                    {product.name}
                  </h4>
                  <span
                    style={{ color: PREVIEW_COLORS.allProducts.productPrice }}
                  >
                    {product.price}원
                  </span>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};
